import {
    useEffect,
    useState,
    type FC
} from "react";
import {
    View
} from "react-native";
import type {
    EventTimerProps
} from "./type";
import stylesheet from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme,
    Text
} from "ncore-ui-kit";
import moment from "moment";

const EventTimer: FC<EventTimerProps> = ({
    startTime
}) => {
    const {
        spaces,
        colors,
        radiuses
    } = NCoreUIKitTheme.useContext();

    const {
        localize
    } = NCoreUIKitLocalize.useContext();

    const [days,
        setDays] = useState<string>("00");
    const [hours,
        setHours] = useState<string>("00");
    const [minutes,
        setMinutes] = useState<string>("00");
    const [seconds,
        setSeconds] = useState<string>("00");

    useEffect(() => {
        const targetTime = moment(startTime);

        const calculateTimeLeft = () => {
            const currentTime = moment();
            const diffInMs = targetTime.diff(currentTime);

            if (diffInMs <= 0) {
                return {
                    _days: "00",
                    _hours: "00",
                    _minutes: "00",
                    _seconds: "00"
                };
            }

            const duration = moment.duration(diffInMs);

            const _days = Math.floor(duration.asDays()).toString().padStart(2, "0");

            const _hours = duration.hours().toString().padStart(2, "0");
            const _minutes = duration.minutes().toString().padStart(2, "0");
            const _seconds = duration.seconds().toString().padStart(2, "0");

            return {
                _days,
                _hours,
                _minutes,
                _seconds
            };
        };

        const updateTimerState = (timeObj: { _days: string, _hours: string, _minutes: string, _seconds: string }) => {
            setDays(timeObj._days);
            setHours(timeObj._hours);
            setMinutes(timeObj._minutes);
            setSeconds(timeObj._seconds);
        };

        updateTimerState(calculateTimeLeft());

        const intervalId = setInterval(() => {
            const newTime = calculateTimeLeft();
            updateTimerState(newTime);

            if (newTime._days === "00" && newTime._hours === "00" && newTime._minutes === "00" && newTime._seconds === "00") {
                clearInterval(intervalId);
            }
        }, 1000);

        return () => clearInterval(intervalId);

    }, [startTime]);

    return <View
        style={{
            marginBottom: spaces.spacingLg,
            ...stylesheet.container
        }}
    >
        <View
            style={[
                stylesheet.timerBox,
                {
                    paddingHorizontal: spaces.spacingXl,
                    paddingVertical: spaces.spacingMd,
                    backgroundColor: colors.project.brandSurface,
                    borderRadius: radiuses.md,
                    marginRight: spaces.spacingMd
                }
            ]}
        >
            <Text
                variant="headlineLargeSize"
            >
                {days}
            </Text>
            <Text
                variant="labelLargeSize"
            >
                {localize("day")}
            </Text>
        </View>
        <View
            style={[
                stylesheet.timerBox,
                {
                    paddingHorizontal: spaces.spacingLg,
                    paddingVertical: spaces.spacingMd,
                    backgroundColor: colors.project.brandSurface,
                    borderRadius: radiuses.md,
                    marginRight: spaces.spacingMd
                }
            ]}
        >
            <Text
                variant="headlineLargeSize"
            >
                {hours}
            </Text>
            <Text
                variant="labelLargeSize"
            >
                {localize("hour")}
            </Text>
        </View>
        <View
            style={[
                stylesheet.timerBox,
                {
                    paddingHorizontal: spaces.spacingLg,
                    paddingVertical: spaces.spacingMd,
                    backgroundColor: colors.project.brandSurface,
                    borderRadius: radiuses.md,
                    marginRight: spaces.spacingMd
                }
            ]}
        >
            <Text
                variant="headlineLargeSize"
            >
                {minutes}
            </Text>
            <Text
                variant="labelLargeSize"
            >
                {localize("min")}
            </Text>
        </View>
        <View
            style={[
                stylesheet.timerBox,
                {
                    paddingHorizontal: spaces.spacingLg,
                    paddingVertical: spaces.spacingMd,
                    backgroundColor: colors.project.brandSurface,
                    borderRadius: radiuses.md
                }
            ]}
        >
            <Text
                variant="headlineLargeSize"
            >
                {seconds}
            </Text>
            <Text
                variant="labelLargeSize"
            >
                {localize("sec")}
            </Text>
        </View>
    </View>;
};
export default EventTimer;
